import { Component, Element, Event, EventEmitter, h, Host, Listen, Prop, State } from "@stencil/core";

@Component({
    tag: "ux-radio-list-item",
    styleUrl: "radio-list-item.scss"
})
export class CheckboxListItem {
    @Element() element!: HTMLUxRadioListItemElement;

    private radioButtonElement: HTMLUxRadioButtonElement;

    /** this value is used on the checkbox inside this item */
    @Prop() readonly value: string;
    /** This is the label that is displayed for this item inside the dropdown */
    @Prop() readonly label: string;
    /** name which is used for checkbox groups or as identifier in forms  */
    @Prop() readonly name: string = "";
    /** indicates if the radio button is checked */
    @Prop() readonly checked: boolean = false;
    /** indicates if the radio button is disabled */
    @Prop() readonly disabled: boolean = false;
    /** Input id attribute to be passed down to the radio button */
    @Prop() readonly inputId?: string;

    @State() isActive: boolean = this.checked;

    /** redispatches the uxRadioButtonChange event, otherwise not interceptable in SPAs */
    @Event({
        eventName: "uxRadioListItemChange",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    radioListItemEvent!: EventEmitter;

    @Listen("uxRadioButtonChange", { target: "window" })
    onRadioListItemChange(e: CustomEvent) {
        if (e.target === this.radioButtonElement) {
            this.radioListItemEvent.emit(e.detail);
            this.isActive = true;
        } else {
            const targetParentDropdown = (e.target as HTMLElement).closest("ux-dropdown");
            const elementParentDropdown = this.element.closest("ux-dropdown");
            if (targetParentDropdown === elementParentDropdown) {
                this.isActive = false;
            }
        }
    }

    render() {
        const baseClass = "ux-radio-list-item";
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--active`]: this.isActive
                }}
                role="listitem"
            >
                <ux-radio-button
                    value={this.value}
                    label={this.label}
                    name={this.name}
                    checked={this.checked}
                    disabled={this.disabled}
                    // @ts-expect-error Check for typing
                    ref={(el) => (this.radioButtonElement = el)}
                    // @ts-expect-error Check for typing
                    inputId={this.inputId || null}
                >
                    <slot />
                </ux-radio-button>
            </Host>
        );
    }
}
